// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .box .add-item {
  padding: 50px 20px 20px 20px;
}
.popup .box .add-item h2 {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .box .add-item form {
  margin-top: 4%;
}
.popup .box .add-item form input {
  background-color: #f5f5f5;
  width: 100%;
  border-radius: 6px;
  outline: none;
  padding: 7% 0% 7% 5%;
  margin-top: 4%;
  border: 0;
  box-sizing: border-box;
  font: 1.4em/1 vigaregular;
}
.popup .box .add-item form input::placeholder {
  opacity: 0.5;
}
.popup .box .add-item form input[name=price] {
  width: 50%;
  margin: 0 6% 0 0;
}
.popup .box .add-item form input[type=file] {
  overflow: hidden;
  height: 0;
  display: none;
}
.popup .box .add-item form textarea {
  margin-top: 5%;
  width: 100%;
  border-radius: 5px;
  height: 22vh;
  border: 0;
  box-sizing: border-box;
  font: 1.4em/1 vigaregular;
  padding: 5% 5% 5% 5%;
  background-color: #f5f5f5;
  resize: none;
  color: #5c5c5c;
}
.popup .box .add-item form textarea::placeholder {
  opacity: 0.5;
}
.popup .box .add-item form .error {
  font: 1.2em/1 vigaregular;
  color: #000;
  padding-top: 2%;
  padding-bottom: 2%;
}
.popup .box .add-item .button-logo a {
  text-decoration: none;
  text-align: center;
  border: 2px solid #caa36c;
  border-radius: 5px;
  padding: 4% 0 4%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.popup .box .add-item .button-logo a span {
  font: 1.4em/1 vigaregular;
  color: #caa36c;
}
.popup .box .add-item .button-logo a span:last-child {
  margin-top: 2%;
  font: 1.1em/1 vigaregular;
  color: #caa36c;
}
.popup .box .add-item .button-image a {
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 0 7%;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 0 7%;
  display: block;
}
.popup .box .add-item .button-image a span {
  font: 1.7em/1 vigaregular;
  color: white;
}
.popup .box .add-item .row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.popup .box .add-item .row .label {
  flex: 1 1;
  min-width: 45%;
}
.popup .box .add-item .row .label h2 {
  font-size: 1.4em;
  line-height: 1.2em;
  padding-right: 10px;
}
.popup .box .add-item .language {
  margin-top: 16%;
}
.popup .box .add-item .bottom {
  margin-top: 5%;
}
.popup .box .add-item .btn-brown {
  background-color: #caa36c;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 2%;
  display: block;
  font: 1.7em/1 vigaregular;
  color: white;
}
.popup .box .add-item .variant-button,
.popup .box .add-item .delete-button {
  border: 1px solid #caa36a;
  border-radius: 5px;
  padding: 20px 12px;
  text-decoration: none;
  display: block;
  text-align: center;
  margin: 0 auto;
  font: 1.2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .box .add-item .variant-button span.icon-add,
.popup .box .add-item .variant-button span.icon-trash,
.popup .box .add-item .variant-button span.icon-edit-bold,
.popup .box .add-item .delete-button span.icon-add,
.popup .box .add-item .delete-button span.icon-trash,
.popup .box .add-item .delete-button span.icon-edit-bold {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
}
.popup .box .add-variant {
  padding: 15% 5%;
}
.popup .box .add-variant h2 {
  font: 2em/1 vigaregular;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #5c5c5c;
  width: 90%;
}
.popup .box .add-variant form {
  margin-top: 4%;
}
.popup .box .add-variant form .row {
  margin-top: 4%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.popup .box .add-variant form .row .label {
  flex: 1 1;
}
.popup .box .add-variant form .row .del-variant {
  margin-left: 3%;
}
.popup .box .add-variant form .row .del-variant span.icon-trash {
  font-size: 16px;
  color: #C9A370;
}
.popup .box .add-variant form .row .del-variant img {
  max-width: 22px;
}
.popup .box .add-variant form input {
  background-color: #f5f5f5;
  width: 100%;
  border-radius: 6px;
  outline: none;
  padding: 7% 0% 7% 5%;
  border: 0;
  box-sizing: border-box;
  font: 1.4em/1 vigaregular;
}
.popup .box .add-variant form input::placeholder {
  opacity: 0.5;
}
.popup .box .add-variant form input[name=price] {
  max-width: 30%;
  margin-left: 4%;
}
.popup .box .add-variant .bottom {
  margin-top: 5%;
}
.popup .box .add-variant .btn-brown {
  background-color: #caa36c;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 2%;
  display: block;
  font: 1.7em/1 vigaregular;
  color: white;
}
.popup .box .add-variant .variant-button,
.popup .box .add-variant .delete-button {
  border: 1px solid #caa36a;
  border-radius: 5px;
  padding: 20px 12px;
  text-decoration: none;
  display: block;
  text-align: center;
  margin: 0 auto;
  font: 1.2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .box .add-variant .variant-button span.icon-add,
.popup .box .add-variant .variant-button span.icon-trash,
.popup .box .add-variant .variant-button span.icon-edit-bold,
.popup .box .add-variant .delete-button span.icon-add,
.popup .box .add-variant .delete-button span.icon-trash,
.popup .box .add-variant .delete-button span.icon-edit-bold {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/AddItemContent.scss"],"names":[],"mappings":"AAEQ;EACI,4BAAA;AADZ;AAGY;EACI,uBAAA;EACA,cAAA;AADhB;AAIY;EACI,cAAA;AAFhB;AAIgB;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;AAFpB;AAIoB;EACI,YAAA;AAFxB;AAMgB;EACI,UAAA;EACA,gBAAA;AAJpB;AAOgB;EACI,gBAAA;EACA,SAAA;EACA,aAAA;AALpB;AAQgB;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;AANpB;AAQoB;EACI,YAAA;AANxB;AAUgB;EACI,yBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AARpB;AAagB;EACI,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAXpB;AAYoB;EACI,yBAAA;EACA,cAAA;AAVxB;AAYwB;EACI,cAAA;EACA,yBAAA;EACA,cAAA;AAV5B;AAiBgB;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAhBpB;AAkBoB;EACI,yBAAA;EACA,YAAA;AAhBxB;AAqBY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAnBhB;AAsBgB;EACI,SAAA;EACA,cAAA;AApBpB;AAsBoB;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;AApBxB;AAyBY;EACI,eAAA;AAvBhB;AA0BY;EACI,cAAA;AAxBhB;AA2BY;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AAzBhB;AA4BY;;EAEI,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;AA1BhB;AA4BgB;;;;;;EAGI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AAvBpB;AA4BQ;EACI,eAAA;AA1BZ;AA4BY;EACI,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AA1BhB;AA6BY;EACI,cAAA;AA3BhB;AA4BgB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA1BpB;AA4BoB;EACI,SAAA;AA1BxB;AA6BoB;EACI,eAAA;AA3BxB;AA6BwB;EACI,eAAA;EACA,cAAA;AA3B5B;AA8BwB;EACI,eAAA;AA5B5B;AAiCgB;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;AA/BpB;AAiCoB;EACI,YAAA;AA/BxB;AAmCgB;EACI,cAAA;EACA,eAAA;AAjCpB;AAqCY;EACI,cAAA;AAnChB;AAsCY;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AApChB;AAuCY;;EAEI,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;AArChB;AAuCgB;;;;;;EAGI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AAlCpB","sourcesContent":[".popup {\n    .box {\n        .add-item {\n            padding: 50px 20px 20px 20px;\n\n            h2 {\n                font: 2em/1 vigaregular;\n                color: #5c5c5c;\n            }\n\n            form {\n                margin-top: 4%;\n\n                input {\n                    background-color: #f5f5f5;\n                    width: 100%;\n                    border-radius: 6px;\n                    outline: none;\n                    padding: 7% 0% 7% 5%;\n                    margin-top: 4%;\n                    border: 0;\n                    box-sizing: border-box;\n                    font: 1.4em/1 vigaregular;\n\n                    &::placeholder {\n                        opacity: 0.5;\n                    }\n                }\n\n                input[name=\"price\"] {\n                    width: 50%;\n                    margin: 0 6% 0 0;\n                }\n\n                input[type=\"file\"] {\n                    overflow: hidden;\n                    height: 0;\n                    display: none;\n                }\n\n                textarea {\n                    margin-top: 5%;\n                    width: 100%;\n                    border-radius: 5px;\n                    height: 22vh;\n                    border: 0;\n                    box-sizing: border-box;\n                    font: 1.4em/1 vigaregular;\n                    padding: 5% 5% 5% 5%;\n                    background-color: #f5f5f5;\n                    resize: none;\n                    color: #5c5c5c;\n\n                    &::placeholder {\n                        opacity: 0.5;\n                    }\n                }\n\n                .error {\n                    font: 1.2em/1 vigaregular;\n                    color: #000;\n                    padding-top: 2%;\n                    padding-bottom: 2%;\n                }\n            }\n\n            .button-logo {\n                a {\n                    text-decoration: none;\n                    text-align: center;\n                    border: 2px solid #caa36c;\n                    border-radius: 5px;\n                    padding: 4% 0 4%;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    flex-direction: column;\n                    span {\n                        font: 1.4em/1 vigaregular;\n                        color:#caa36c;\n\n                        &:last-child {\n                            margin-top: 2%;\n                            font: 1.1em/1 vigaregular;\n                            color:#caa36c;\n                        }\n                    }\n                }\n            }\n\n            .button-image {\n                a {\n                    text-decoration: none;\n                    text-align: center;\n                    border-radius: 5px;\n                    padding: 7% 0 7%;\n\n                    text-decoration: none;\n                    text-align: center;\n                    border-radius: 5px;\n                    padding: 7% 0 7%;\n                    display: block;\n\n                    span {\n                        font: 1.7em/1 vigaregular;\n                        color: white;\n                    }\n                }\n            }\n\n            .row {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n\n                \n                .label {\n                    flex: 1;\n                    min-width: 45%;\n\n                    h2 {\n                        font-size: 1.4em;\n                        line-height: 1.2em;\n                        padding-right: 10px;\n                    }\n                }\n            }\n\n            .language {\n                margin-top: 16%;\n            }\n\n            .bottom {\n                margin-top: 5%;\n            }\n\n            .btn-brown {\n                background-color: #caa36c;\n                text-decoration: none;\n                text-align: center;\n                border-radius: 5px;\n                padding: 7% 2%;\n                display: block;\n                font: 1.7em/1 vigaregular;\n                color: white;\n            }\n\n            .variant-button,\n            .delete-button {\n                border: 1px solid #caa36a;\n                border-radius: 5px;\n                padding: 20px 12px;\n                text-decoration: none;\n                display: block;\n                text-align: center;\n                margin: 0 auto;\n                font: 1.2em/1 vigaregular;\n                color: #5c5c5c;\n\n                span.icon-add,\n                span.icon-trash,\n                span.icon-edit-bold{\n                    position: absolute;\n                    right: 15px;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    font-size: 16px;\n                }\n            }\n        }\n\n        .add-variant {\n            padding: 15% 5%;\n\n            h2 {\n                font: 2em/1 vigaregular;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                overflow: hidden;\n                color: #5c5c5c;\n                width: 90%;\n            }\n\n            form {\n                margin-top: 4%;\n                .row {\n                    margin-top: 4%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: space-between;\n\n                    .label {\n                        flex: 1;\n                    }\n\n                    .del-variant {\n                        margin-left: 3%;\n\n                        span.icon-trash{\n                            font-size: 16px;\n                            color: #C9A370;\n                        }\n\n                        img {\n                            max-width: 22px;\n                        }\n                    }\n                }\n\n                input {\n                    background-color: #f5f5f5;\n                    width: 100%;\n                    border-radius: 6px;\n                    outline: none;\n                    padding: 7% 0% 7% 5%;\n                    border: 0;\n                    box-sizing: border-box;\n                    font: 1.4em/1 vigaregular;\n\n                    &::placeholder {\n                        opacity: 0.5;\n                    }\n                }\n\n                input[name=\"price\"] {\n                    max-width: 30%;\n                    margin-left: 4%;\n                }\n            }\n\n            .bottom {\n                margin-top: 5%;\n            }\n\n            .btn-brown {\n                background-color: #caa36c;\n                text-decoration: none;\n                text-align: center;\n                border-radius: 5px;\n                padding: 7% 2%;\n                display: block;\n                font: 1.7em/1 vigaregular;\n                color: white;\n            }\n\n            .variant-button,\n            .delete-button {\n                border: 1px solid #caa36a;\n                border-radius: 5px;\n                padding: 20px 12px;\n                text-decoration: none;\n                display: block;\n                text-align: center;\n                margin: 0 auto;\n                font: 1.2em/1 vigaregular;\n                color: #5c5c5c;\n\n                span.icon-add,\n                span.icon-trash,\n                span.icon-edit-bold{\n                    position: absolute;\n                    right: 15px;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    font-size: 16px;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
